<template>
  <DocumentForm is-master>
    <p>Use the form below to set the default values for this document. The form will be prepopulated with these values when you create a new document.</p>
  </DocumentForm>
</template>

<script>
import DocumentForm from './DocumentForm.vue'

export default {
  components: { DocumentForm }
}
</script>
